import {Space, SpinLoading} from "antd-mobile";
import React from "react";
import LoadingGif from '@/assets/images/jcj_loading.gif'

// 预加载 GIF 图片，确保浏览器缓存
const preloadImage = new Image();
preloadImage.src = LoadingGif;

const CircleLoading = ()=>{
  return <Space direction='vertical' justify='center' align='center' block style={{ 'height': '100vh','width': '100vw' }}>
    <SpinLoading style={{ '--size': '48px' }} />
  </Space>
}

const DZLoading = ()=>{

  return <Space direction='vertical' justify='center' align='center'  block style={{ 'height': '100vh','width': '100vw','--gap':'0' }}>
    <img
        src={LoadingGif}
        style={{width:'0.48rem',height:'0.48rem'}}
        alt="loading"
    />
    <div style={{fontSize:'0.14rem',color:'#ccc',fontFamily:'PingFang SC'}}>加载中...</div>
  </Space>
}

const PageLoading = ()=>{
  return <DZLoading/>
}

export default PageLoading

